export default "__VITE_ASSET__l2YzA8ke__"